import { createUseQueryHook } from './createUseQueryHook';

export const useAllowedDocumentsWithExtPersons = createUseQueryHook(
    'get_allowed_documents_with_ext_persons',
    { staleTime: Infinity },
);
